<script>
    /**
     * Callback.
     *
     * @type {(() => void) | null}
     */
    export let onClick = null;
    export let href = ''; // Add href prop
</script>

<div class="fixed bottom-16 right-16">
    {#if href}
        <a
            class="py-1 px-6 h-16 bg-green-600 rounded-full hover:bg-green-700 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none flex flex-row gap-2 items-center text-white"
            href={href}>
            <slot name="icon" />
            <span><slot/></span>
        </a>
    {:else}
        <button
            class="py-1 px-6 h-16 bg-green-600 rounded-full hover:bg-green-700 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none flex flex-row gap-2 items-center text-white"
            on:click={onClick}>
            <slot name="icon" />
            <span><slot/></span>
        </button>
    {/if}
</div>